import type { FunctionalComponent } from "preact";

export interface Props {
    text: string;
}

const Headline: FunctionalComponent<Props> = (props) => {
    // biome-ignore lint/security/noDangerouslySetInnerHtml: no user input
    return <p class="text-white text-xs tracking-tightest" dangerouslySetInnerHTML={{ __html: props.text }} />;
};

export default Headline;
